import Vue from 'vue';
import Vuex from 'vuex';
import userPerformance from './userPerformance';
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        userPerformance
    },
    state: {
        welcome: 'Welcome to Vue2-starter!'
    },
});
